import { memo } from 'react';
import { Link } from 'react-router-dom';
import cx from 'classnames';

import { BALANCES_PAGE } from 'site-settings/site-navigation';
import { LogoWrap, LogoBox, LogoImage, LogoText } from './logo.style';

type LogoProps = {
  imageUrl: string;
  text?: string;
  alt?: string;
};

const Logo = ({ imageUrl, text = '', alt = '' }: LogoProps) => {
  return (
    <LogoWrap
      className={cx({
        withText: text !== ''
      })}
    >
      <Link to={BALANCES_PAGE}>
        <LogoBox>
          <LogoImage src={imageUrl} alt={alt} />
          {text !== '' && <LogoText>{text}</LogoText>}
        </LogoBox>
      </Link>
    </LogoWrap>
  );
};

export default memo(Logo);
